module.exports = __webpack_public_path__ + "e67f74a1a87ec6f58789fe387e7435a5.svg";